import { styled } from "@mui/material";


export const BoxFolder = styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection:"row",
    gap: 6,
    padding:"0 10px",
    cursor: "pointer"
})
